import $ from "jquery";
import {
  ARIA,
  VDARA,
  BELLAGIO,
  PARK_MGM,
  THE_COSMOPOLITAN,
  NOMAD,
  DISTRICT_HIGHLIGHTS,
  DOLBY,
  TMOBILE,
} from "../scripts/core/constants";
import { __setScale } from "../layouts/ZoomButtons.js";
import {
  Aria,
  Vdara,
  Bellagio,
  ParkMGM,
  TCOLV,
  DistrictHighlight,
  Nomad,
} from "../list/listItems.js";
import {
  _changeLevel,
  _getCurrentAriaLevel,
} from "../components/DollhouseMapContainer.js";
import { __showDollHouseModal } from "./HotspotInfoModal";
import { _IntoTabClick } from "../layouts/SideBar";

let globalHotspotHvervar = null;

export const resetDollhouseMap = () => {
  $(".aria-marker").css("display", "none");
  $(".aria-marker-Level").css("display", "none");
  $(".vdara-marker").css("display", "none");
  $(".bagio-marker").css("display", "none");

  $(".parkmgm-marker").css("display", "none");
  $(".nomad-marker").css("display", "none");
  $(".cosmopolitcal-marker").css("display", "none");
  $(".cosmopolitcal-marker-Level").css("display", "none");
};

let LeftMarginValue = 320;

export const setDollhouseMap = (
  selectedbuilding,
  currentMapLevel,
  hoverContent
) => {
  if (globalHotspotHvervar === null) {
    globalHotspotHvervar = hoverContent;
  }

  // console.log("selectedbuilding", selectedbuilding);
  if (selectedbuilding === ARIA) {
    resetDollhouseMap();
    $(".common-maker").css("display", "none");

    if (currentMapLevel === "area_level_2") {
      $(".aria-marker").css("top", "28%");
      $(".aria-marker").css("left", "21%");
    } else {
      $(".aria-marker").css("top", "40%");
      $(".aria-marker").css("left", "25%");
    }
    $(".aria-marker-Level").css("display", "block");
    $(".aria-marker").css("display", "block");
    $(".aria-marker").css("transform", "scale(0.5)");
  }

  if (selectedbuilding === VDARA) {
    resetDollhouseMap();

    $(".common-maker").css("display", "none");
    $(".vdara-marker").css("transform", "scale(0.5)");
    $(".vdara-marker").css("display", "block");
  }

  if (selectedbuilding === BELLAGIO) {
    resetDollhouseMap();

    $(".common-maker").css("display", "none");
    $(".bagio-marker").css("display", "block");
    $(".bagio-marker").css("transform", "scale(0.5)");
  }

  if (selectedbuilding === PARK_MGM) {
    resetDollhouseMap();

    $(".common-maker").css("display", "none");
    $(".parkmgm-marker").css("transform", "scale(0.5)");

    $(".parkmgm-marker").css("display", "block");
  }
  if (selectedbuilding === NOMAD) {
    resetDollhouseMap();

    $(".common-maker").css("display", "none");
    $(".nomad-marker").css("transform", "scale(0.5)");
    $(".nomad-marker").css("display", "block");
  }

  if (selectedbuilding === DISTRICT_HIGHLIGHTS) {
    resetDollhouseMap();

    $(".common-maker").css("display", "none");
  }

  if (selectedbuilding === THE_COSMOPOLITAN) {
    resetDollhouseMap();

    $(".common-maker").css("display", "none");
    $(".cosmopolitcal-marker").css("transform", "scale(0.5)");
    $(".cosmopolitcal-marker").css("display", "block");
    $(".cosmopolitcal-marker-Level").css("display", "block");
  }
  if (selectedbuilding === TMOBILE) {
    resetDollhouseMap();
  }

  if (selectedbuilding === DOLBY) {
    resetDollhouseMap();
  }
};

export function resetAllMapPathSvg() {
  document.querySelectorAll(".svg-path").forEach((val) => {
    val.classList.remove("svg-walk-path-display");
    val.classList.remove("svg-tram-path-display");
  });

  document.querySelectorAll(".path-time-info").forEach((val) => {
    val.classList.remove("visibile-path-time-info");
    val.classList.add("hidden-path-time-info");
  });

  document.querySelectorAll(".path_info_popup").forEach((val) => {
    val.style.opacity = 0;
  });
}
export function getMapSourceDestinationPaths() {
  return fetch("data/json/mapPathRouteInformation.json", {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  }).then((res) => res.json());
}

export function filterListItem(poid) {
  let newArr = null;

  Aria.forEach((val) => {
    if (val.poiId === poid) {
      newArr = val;
    }
  });

  if (newArr === null) {
    Vdara.forEach((val) => {
      if (val.poiId === poid) {
        newArr = val;
      }
    });
  }

  if (newArr === null) {
    Bellagio.forEach((val) => {
      if (val.poiId === poid) {
        newArr = val;
      }
    });
  }

  if (newArr === null) {
    ParkMGM.forEach((val) => {
      if (val.poiId === poid) {
        newArr = val;
      }
    });
  }

  if (newArr === null) {
    TCOLV.forEach((val) => {
      if (val.poiId === poid) {
        newArr = val;
      }
    });
  }

  if (newArr === null) {
    DistrictHighlight.forEach((val) => {
      if (val.poiId === poid) {
        newArr = val;
      }
    });
  }

  if (newArr === null) {
    Nomad.forEach((val) => {
      if (val.poiId === poid) {
        newArr = val;
      }
    });
  }

  return newArr;
}

export function animationStart(poid) {
  const groupElement = document.getElementById("hotspot_" + poid);
  if (groupElement) {
    // Get the current transform attribute value
    const currentTransform = groupElement.getAttribute("transform");

    // Parse the current X and Y values from the transform attribute
    const match = /translate\(\s*(\d+)\s+(\d+)\s*\)/.exec(currentTransform);
    const currentX = parseInt(match[1], 10);
    const currentY = parseInt(match[2], 10);

    // Calculate the new X and Y values (add 10 to each)
    const newX = currentX;
    const newY = currentY - 10;

    // Update the transform attribute with the new X and Y values
    groupElement.setAttribute("transform", `translate(${newX} ${newY})`);
  }
}

export function animationEnd(poid) {
  const groupElement = document.getElementById("hotspot_" + poid);
  if (groupElement) {
    // Get the current transform attribute value
    const currentTransform = groupElement.getAttribute("transform");

    // Parse the current X and Y values from the transform attribute
    const match = /translate\(\s*(\d+)\s+(\d+)\s*\)/.exec(currentTransform);
    const currentX = parseInt(match[1], 10);
    const currentY = parseInt(match[2], 10);

    // Calculate the new X and Y values (add 10 to each)
    const newX = currentX;
    const newY = currentY + 10;

    // Update the transform attribute with the new X and Y values
    groupElement.setAttribute("transform", `translate(${newX} ${newY})`);
  }
}

let mousedowndragging = false;
window.addEventListener("mousedown", () => {
  mousedowndragging = true;
});
window.addEventListener("mouseup", () => {
  mousedowndragging = false;
});

export function __getOffsetValues(value) {
  LeftMarginValue = value;
}

export function showPopupWithContent(e, poid) {
  if (!mousedowndragging) {
    console.log();
    // __showDollHouseModal(true, e.clientX - LeftMarginValue, e.clientY, poid);
    __showDollHouseModal(true, e.clientX, e.clientY, poid);
  }
}

export function hidePopup(poid) {
  // setTimeout(() => {
  //   __showDollHouseModal(false, 0, 0, "");
  // }, 1000);
  // console.log("hided");
  // let timercheck = setTimeout(() => {
  //   __showDollHouseModal(false, 0, 0, '');
  //   if (document.querySelector("#hotspot_info_" + poid)) {
  //     let element = document.querySelector("#hotspot_info_" + poid);
  //     if (element.classList.contains("mouse-in")) {
  //     } else {
  //       document.querySelector("#hotspot_info_" + poid).style.visibility =
  //         "hidden";
  //     }
  //   }
  //   clearTimeout(timercheck);
  // }, 500);
}
export function handleMouseEnterPoupHiding() {
  // console.log('called----','__showDollHouseModal');
  __showDollHouseModal(false, 0, 0, "");
}
export function getDestinationSelectedAria(val) {
  let destination = null;

  if (val === BELLAGIO) {
    destination = {
      name: "Convention Area",
      level: "",
      poiId: "bellagio_convention",
      dollhousemapId: "DlHse_RO_Aria_L1",
      isActive: false,
      map: "Bellagio",
    };
  }

  if (val === ARIA) {
    destination = {
      name: "West Convention Center",
      level: "area_level_1",
      poiId: "aria_west_convention_center",
      dollhousemapId: "DlHse_RO_Aria_L2",
      isActive: false,
      map: "Aria2",
    };
  }

  if (val === VDARA) {
    destination = {
      name: "Vinoly",
      level: "",
      poiId: "vdara_vinoly",
      dollhousemapId: "DlHse_RO_Aria_L1",
      isActive: false,
      map: "Vdara",
    };
  }
  if (val === THE_COSMOPOLITAN) {
    destination = {
      name: "Convention Area - Level 2",
      level: "cosmo_level_2",
      poiId: "cosmo_convention_area_2",
      dollhousemapId: "DlHse_RO_L1_wTCOLV_L2",
      isActive: false,
      map: "Tcolv",
    };
  }
  if (val === PARK_MGM) {
    destination = {
      name: "Convention Area",
      level: "",
      poiId: "park_mgm_convention_area",
      dollhousemapId: "DlHse_RO_Aria_L1",
      isActive: false,
      map: "ParkMgm",
    };
  }

  if (val === NOMAD) {
    destination = {
      name: "Elevators",
      level: "",
      poiId: "no_mad_elevators",
      dollhousemapId: "DlHse_RO_Aria_L1",
      isActive: false,
      map: "Nomad",
    };
  }

  if (val === DOLBY) {
    destination = {
      name: "Dolby Live Theater",
      level: "",
      poiId: "park_mgm_dolby_live",
      dollhousemapId: "DlHse_RO_Aria_L1",
      isActive: false,
      map: "DistrictHighlight",
    };
  }

  if (val === TMOBILE) {
    destination = {
      name: "T Mobile Arena",
      level: "",
      poiId: "district_highlight_t_mobile",
      dollhousemapId: "DlHse_RO_Aria_L1",
      isActive: false,
      map: "DistrictHighlight",
    };
  }

  return destination;
}

export function getSourceSelectedAria(val) {
  let source = null;

  if (val === BELLAGIO) {
    source = {
      name: "Convention Area",
      level: "",
      poiId: "bellagio_convention",
      dollhousemapId: "DlHse_RO_Aria_L1",
      isActive: false,
      map: "Bellagio",
    };
  }

  if (val === ARIA) {
    source = {
      name: "West Convention Center",
      level: "area_level_1",
      poiId: "aria_west_convention_center",
      dollhousemapId: "DlHse_RO_Aria_L2",
      isActive: false,
      map: "Aria2",
    };
  }
  if (val === VDARA) {
    source = {
      name: "Vinoly",
      level: "",
      poiId: "vdara_vinoly",
      dollhousemapId: "DlHse_RO_Aria_L1",
      isActive: false,
      map: "Vdara",
    };
  }
  if (val === THE_COSMOPOLITAN) {
    source = {
      name: "Convention Area - Level 2",
      level: "cosmo_level_2",
      poiId: "cosmo_convention_area_2",
      dollhousemapId: "DlHse_RO_L1_wTCOLV_L2",
      isActive: false,
      map: "Tcolv",
    };
  }
  if (val === PARK_MGM) {
    source = {
      name: "Convention Area",
      level: "",
      poiId: "park_mgm_convention_area",
      dollhousemapId: "DlHse_RO_Aria_L1",
      isActive: false,
      map: "ParkMgm",
    };
  }

  if (val === NOMAD) {
    source = {
      name: "Elevators",
      level: "",
      poiId: "no_mad_elevators",
      dollhousemapId: "DlHse_RO_Aria_L1",
      isActive: false,
      map: "Nomad",
    };
  }

  if (val === DOLBY) {
    source = {
      name: "Dolby Live Theater",
      level: "",
      poiId: "park_mgm_dolby_live",
      dollhousemapId: "DlHse_RO_Aria_L1",
      isActive: false,
      map: "DistrictHighlight",
    };
  }

  if (val === TMOBILE) {
    source = {
      name: "T Mobile Arena",
      level: "",
      poiId: "district_highlight_t_mobile",
      dollhousemapId: "DlHse_RO_Aria_L1",
      isActive: false,
      map: "DistrictHighlight",
    };
  }

  return source;
}
